module.exports = __webpack_public_path__ + "static/media/mich_and2.2b8014f6.jpg";